function feedImages() {

    imageCards.forEach((imageCard) => {
        const imageSlides = imageCard.querySelectorAll('.js-image-card-slide');
        let timer, activeSlideIndex = 0;
        imageSlides[0].classList.add('is-active');

        imageCard.addEventListener("mouseover", () => {
            timer = setInterval(function () {
                const totalSlides = imageSlides.length - 1;
                
                if (activeSlideIndex >= totalSlides) {
                    activeSlideIndex = 0;
                } else {
                    activeSlideIndex++;
                }
                imageSlides.forEach((imageSlide) => {
                    imageSlide.classList.remove("is-active");
                });
                imageSlides[activeSlideIndex].classList.add("is-active");
                
            }, 600);
        });

        imageCard.addEventListener("mouseout", () => {
            clearInterval(timer);
        });
    });

}

